import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Selectors } from '@grandvisionhq/auth';
import { useIntl, useSelector } from '@grandvisionhq/state';
import AppointmentError from './AppointmentError.js';

const AppointmentErrorContainer = (_param)=>{
    var { status , bookAppointmentUrl  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "status",
        "bookAppointmentUrl"
    ]);
    const { getLabel  } = useIntl();
    const routes = useSelector(Selectors.getFormattedRoutes);
    const isTokenNotFoundStatus = status === 'JWT_TOKEN_NOT_FOUND';
    const labels = React.useMemo(()=>({
            title: getLabel(`appointments.component.appointmentError.${status}.title`),
            description: getLabel(`appointments.component.appointmentError.${status}.description`),
            buttonCaption: getLabel(`appointments.component.appointmentError.${isTokenNotFoundStatus ? 'goToMyAccount' : 'bookAppointment'}`),
            goToHome: getLabel('appointments.component.appointmentError.goToHome')
        })
    , [
        getLabel,
        status,
        isTokenNotFoundStatus
    ]);
    const buttonUrl = React.useMemo(()=>{
        if (isTokenNotFoundStatus) {
            const origin = typeof window === 'undefined' ? '' : window.location.origin;
            const returnPath = !origin ? '' : `${window.location.pathname}${window.location.search}`;
            return `${origin}${routes === null || routes === void 0 ? void 0 : routes.login}?returnPath=${returnPath}`;
        }
        return bookAppointmentUrl;
    }, [
        isTokenNotFoundStatus,
        bookAppointmentUrl,
        routes
    ]);
    return /*#__PURE__*/ React.createElement(AppointmentError, swcHelpers.extends({}, rest, {
        labels: labels,
        buttonUrl: buttonUrl
    }));
};

export { AppointmentErrorContainer as default };
//# sourceMappingURL=AppointmentErrorContainer.js.map
